var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main---search",
    transform: "translate(-141.000000, -41.000000)",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(142.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4507042,9.49013239 C17.4507042,13.8760479 13.8760563,17.4506958 9.49014085,17.4506958 C5.10422535,17.4506958 1.52957746,13.8760479 1.52957746,9.49013239 C1.52957746,5.1042169 5.10422535,1.52956901 9.49014085,1.52956901 C13.8760563,1.52956901 17.4507042,5.0957662 17.4507042,9.49013239 M23.7295775,22.6563296 L16.7070423,15.6337944 C18.1690141,13.9183014 18.971831,11.7380197 18.971831,9.49013239 C18.971831,4.25914648 14.7126761,-8.45070423e-06 9.49014085,-8.45070423e-06 C4.25915493,-8.45070423e-06 0,4.25914648 0,9.49013239 C0,14.7211183 4.25915493,18.9802732 9.49014085,18.9802732 C11.7380282,18.9802732 13.9098592,18.1774563 15.6253521,16.7154845 L22.6647887,23.7381042 C22.8169014,23.8901324 23.0028169,23.957738 23.1971831,23.957738 C23.3915493,23.957738 23.5859155,23.8816817 23.7295775,23.7381042 C23.8732394,23.5943577 23.9492958,23.4000761 23.9492958,23.1971746 C23.9577465,22.9943577 23.8732394,22.7999915 23.7295775,22.6563296",
    id: "Fill-1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/search.icon.420c8b28.svg";
export { ForwardRef as ReactComponent };